import React from 'react';
import { RouterProvider } from 'react-router';
import { StyledEngineProvider } from '@mui/material/styles';
import { LocalizationProvider } from '@mui/x-date-pickers';
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';
import 'dayjs/locale/ru';
import { CartProvider } from 'utils/cart';
import router from './view/Routes';
import dayjs from 'dayjs';
dayjs.locale('ru')

const App = () => {
    return (
        <StyledEngineProvider injectFirst>
            <LocalizationProvider dateAdapter={AdapterDayjs} adapterLocale='ru'>
                <CartProvider>
                    <RouterProvider router={router} />
                </CartProvider>
            </LocalizationProvider>
        </StyledEngineProvider>
    )
}

export default App;
